const suspectData = [
    {
        id: 1,
        name: "Nigel Haysmith",
        image: "images/mugshots/nigelHaysmithMugshot.jpg",
        description: "Impressive mustache. Born 12th July 1886.",
    },
    {
        id: 2,
        name: "Logan Eckart",
        image: "images/mugshots/loganEckartMugshot.jpg",
        description: "Ambitious and driven. Brown eyes.",
    },
    {
        id: 3,
        name: "Tara Smythe",
        image: "images/mugshots/taraSmytheMugshot.jpg",
        description: "Her British accent cuts straight through the nonsense.",
    },
    {
        id: 4,
        name: "Bruce Esherwood",
        image: "images/mugshots/bruceEsherwoodMugshot.jpg",
        description: "Shorter than Nigel, taller than Tara.",
    },
    {
        id: 5,
        name: "Dorris Humphries",
        image: "images/mugshots/dorrisHumphriesMugshot.jpg",
        description: "Always wears gloves. The eldest of the suspects.",
    },
    {
        id: 6,
        name: "Harriette Watts",
        image: "images/mugshots/rubyLoxMugshot.jpg",
        description: "Piercing eyes. Same color as the entrance hall seats.",
    },
    {
        id: 7,
        name: "Mary Floyd",
        image: "images/mugshots/maryFloydMugshot2.png",
        description: "Imposing stature. By far the tallest suspect.",
    }
]

export default suspectData